import { Box, Typography } from '@mui/material';

export const DetailField = ({ label, value }) => (
  <Box>
    <Typography variant='caption' color='text.secondary'>
      {label}
    </Typography>
    <Typography variant='body1'>{value}</Typography>
  </Box>
);
